import React, { Suspense } from "react"
import { RouteProps } from "react-router-dom"

export function withSuspense<T>(Component: React.ComponentType<T>, FallbackComponent = null) {
  return (props: RouteProps & T) => (
    <Suspense fallback={FallbackComponent}>
      <Component {...props} />
    </Suspense>
  )
}
